<template>
  <div class="ksm-flex-xy-center">
    <h1 style="width:100%; text-align: center; color: grey">Hilfe</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss"
 scoped>
</style>


// WEBPACK FOOTER //
// Hilfe.vue?49ba5a90